<neoris-nav-menu [loginResponse]="loginResponse"></neoris-nav-menu>
<neoris-notifications-mini-area *ngIf="alertType=='I4SAFETY_MINI'" ></neoris-notifications-mini-area> 
 <neoris-notifications-box-area *ngIf="alertType=='I4SAFETY_BOX'"  style="pointer-events: none;"> </neoris-notifications-box-area>
<div class="container">
  <router-outlet></router-outlet>
</div>
<!-- <span class="pais-toas-temp">
  {{location}}
</span> -->